import { ProductWebinarHelper } from '..';

export const useProductWebinar = () => {
	let productWebinarHelper = new ProductWebinarHelper();
	return {
		productWebinarHelper,
		activeProductWebinar: productWebinarHelper.active()
	};
};
